
import { EmptyResponse_$reflection, BusinessUnitId, SetId, DocumentDetail_$reflection, RequestedValue$1 } from "../../Shared/Shared.js";
import { tryFind, contains, map, append, choose, fold, isEmpty, filter, ofArray, singleton, empty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Msg, State } from "./Types.js";
import { Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { addPrefix, fetchWithDecoder } from "../../Communication.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { DataTransfer_CreateOrUpdateSet, DataTransfer_UpdateQrCodesDto_$reflection, DataTransfer_UpdateQrCodesDto, DataTransfer_ProblemReportTool_$reflection, DataTransfer_DetailSet_$reflection, DataTransfer_CreateOrUpdateSet_$reflection } from "../../Shared/Set.js";
import { concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { getAssignableTools, downloadFileCmd, updateImages, getAssignableToolsWithSetId } from "../../Requests/Set.js";
import { UserConfiguration as UserConfiguration_1, QuickOverviewConfiguration as QuickOverviewConfiguration_1, UserConfiguration_$reflection } from "../../Shared/User.js";
import { getCustomerConfiguration } from "../../Requests/Configuration.js";
import { Storage_$reflection } from "../../Shared/Storage.js";
import { option_type, tuple_type, int32_type, string_type, list_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { BusinessUnitId__get_unwrap, SetId__get_unwrap } from "../../Shared/Shared.js";
import { getSetNotifications } from "../../Requests/Notification.js";
import { getAccountSettings } from "../../Requests/Customer.js";
import { NoticeDto_$reflection, NoticeDto } from "../../Shared/Tool.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { unwrapNoticeId } from "../../Shared/Helper.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { fetchWithDecoder as fetchWithDecoder_1, addPrefix as addPrefix_1 } from "../../CommunicationV2.js";
import { stringHash, int32ToString } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { UpdateImagesDto } from "../../Shared/Image.js";
import { Cmd_ofEffect } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { DnDFormImage } from "../../Widgets/Image/ImageUploadDnD.js";
import { singleton as singleton_1, append as append_1, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { ValidationOnGetRequest } from "../../ErrorHandling.js";
import { getBlob, onBlobReceived } from "../../Communication.js";
import { List_distinct } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { getChangelogs } from "../../Requests/Changelog.js";

function initState(userData) {
    return new State(new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, []), userData, undefined, {
        IsLoading: false,
        IsOpen: false,
    }, new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, []), empty(), new RequestedValue$1(0, []), new RequestedValue$1(0, []));
}

export function initViewSet(setId, userData) {
    let bind$0040;
    return [(bind$0040 = initState(userData), new State(bind$0040.Set, bind$0040.Tools, bind$0040.UserConfiguration, bind$0040.UserData, userData.Customer, bind$0040.QuickOverviewDialog, bind$0040.Documents, bind$0040.CustomerConfiguration, bind$0040.Storages, bind$0040.BaseSet, bind$0040.ProblemReports, bind$0040.Notifications, bind$0040.Changelogs, bind$0040.SetImages, bind$0040.AccountSettings, bind$0040.BusinessUnitImageUrl)), Cmd_batch(ofArray([Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), DataTransfer_CreateOrUpdateSet_$reflection()));
    })))), concat("/api/sets/", setId, ..."/basis"), (Item) => (new Msg(21, [Item])), (Item_1) => (new Msg(39, [Item_1]))), Cmd_OfPromise_either((url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url_3), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_1) => {
        const pr_1 = response_1.arrayBuffer();
        return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), DataTransfer_DetailSet_$reflection()));
    })))), concat("/api/sets/", setId, ..."/details"), (Item_2) => (new Msg(2, [Item_2])), (Item_3) => (new Msg(39, [Item_3]))), getAssignableToolsWithSetId((Item_4) => (new Msg(26, [Item_4])), (Item_5) => (new Msg(39, [Item_5])), setId), Cmd_OfPromise_either((url_6) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url_6), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_2) => {
        const pr_2 = response_2.arrayBuffer();
        return pr_2.then((blob_2) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_2)), UserConfiguration_$reflection()));
    })))), "/api/users/configuration", (Item_6) => (new Msg(17, [Item_6])), (Item_7) => (new Msg(39, [Item_7]))), getCustomerConfiguration((Item_8) => (new Msg(27, [Item_8])), (Item_9) => (new Msg(39, [Item_9]))), Cmd_OfPromise_either((url_9) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url_9), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_3) => {
        const pr_3 = response_3.arrayBuffer();
        return pr_3.then((blob_3) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_3)), list_type(Storage_$reflection())));
    })))), "/api/storages", (Item_10) => (new Msg(28, [Item_10])), (Item_11) => (new Msg(39, [Item_11]))), Cmd_OfPromise_either((url_12) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url_12), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_4) => {
        const pr_4 = response_4.arrayBuffer();
        return pr_4.then((blob_4) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_4)), list_type(DocumentDetail_$reflection())));
    })))), concat("/api/sets/", SetId__get_unwrap(new SetId(setId)), ..."/documents"), (Item_12) => (new Msg(25, [Item_12])), (Item_13) => (new Msg(39, [Item_13]))), Cmd_OfPromise_either((url_15) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url_15), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_5) => {
        const pr_5 = response_5.arrayBuffer();
        return pr_5.then((blob_5) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_5)), list_type(DataTransfer_ProblemReportTool_$reflection())));
    })))), concat("/api/sets/", SetId__get_unwrap(new SetId(setId)), ..."/problem-reports"), (Item_14) => (new Msg(29, [Item_14])), (Item_15) => (new Msg(39, [Item_15]))), getSetNotifications(new SetId(setId), (Item_16) => (new Msg(33, [Item_16])), (Item_17) => (new Msg(39, [Item_17]))), getAccountSettings((Item_18) => (new Msg(38, [Item_18])), (Item_19) => (new Msg(39, [Item_19])))]))];
}

export function update(msg, state) {
    let setId, body_5, setId_4, body_7, setId_5, body_9, setId_6, body_11, setId_7, body_13, userConfiguration_1, bind$0040_1;
    switch (msg.tag) {
        case 1:
            return [new State(state.Set, state.Tools, state.UserConfiguration, state.UserData, state.Customer, {
                IsLoading: state.QuickOverviewDialog.IsLoading,
                IsOpen: !state.QuickOverviewDialog.IsOpen,
            }, state.Documents, state.CustomerConfiguration, state.Storages, state.BaseSet, state.ProblemReports, state.Notifications, state.Changelogs, state.SetImages, state.AccountSettings, state.BusinessUnitImageUrl), Cmd_none()];
        case 5: {
            const matchValue_1 = state.Set;
            if (matchValue_1.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const dto = new NoticeDto("00000000-0000-0000-0000-000000000000", matchValue_1.fields[0].Id, "", msg.fields[0], msg.fields[1]);
                return [state, Cmd_OfPromise_either((tupledArg_1) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(tupledArg_1[0]), ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg_1[1]])]), "application/json", (response_1) => {
                    const pr_1 = response_1.arrayBuffer();
                    return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), string_type));
                })))), ["/api/sets/notices", toString(0, Auto_generateBoxedEncoder_437914C6(NoticeDto_$reflection(), undefined, undefined, undefined)(dto))], (Item_2) => (new Msg(6, [Item_2])), (Item_3) => (new Msg(39, [Item_3])))];
            }
        }
        case 6: {
            const response_2 = msg.fields[0];
            switch (response_2) {
                case "updated":
                    return [state, singleton((dispatch_1) => {
                        dispatch_1(new Msg(30, []));
                    })];
                case "notAuthorized":
                    return [state, Cmd_errorToast("set.form.validation_errors.not_authorized")];
                default:
                    return [state, singleton((dispatch) => {
                        dispatch(new Msg(30, []));
                    })];
            }
        }
        case 7: {
            const notice = msg.fields[0];
            const matchValue_2 = state.Set;
            if (matchValue_2.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const dto_1 = new NoticeDto(unwrapNoticeId(notice.Id), "", "", notice.Message, notice.IsVisibleForUser);
                return [state, (setId = (new SetId(parse(matchValue_2.fields[0].Id))), (body_5 = toString(0, Auto_generateBoxedEncoder_437914C6(NoticeDto_$reflection(), undefined, undefined, undefined)(dto_1)), Cmd_OfPromise_either((tupledArg_2) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(tupledArg_2[0]), ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg_2[1]])]), "application/json", (response_3) => {
                    const pr_2 = response_3.arrayBuffer();
                    return pr_2.then((blob_2) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_2)), string_type));
                })))), [concat("/api/sets/", SetId__get_unwrap(setId), ..."/notices"), body_5], (Item_4) => (new Msg(6, [Item_4])), (Item_5) => (new Msg(39, [Item_5])))))];
            }
        }
        case 8:
            return [new State(state.Set, state.Tools, state.UserConfiguration, state.UserData, state.Customer, state.QuickOverviewDialog, state.Documents, state.CustomerConfiguration, state.Storages, state.BaseSet, state.ProblemReports, state.Notifications, state.Changelogs, msg.fields[0], state.AccountSettings, state.BusinessUnitImageUrl), Cmd_none()];
        case 9:
            if (state.Set.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const newImages = filter((image) => {
                    if (image.tag === 1) {
                        return false;
                    }
                    else {
                        return true;
                    }
                }, state.SetImages);
                if (!isEmpty(newImages)) {
                    return [state, Cmd_OfPromise_either((tupledArg_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        let url_11;
                        return ((url_11 = addPrefix_1(tupledArg_3[0]), (refreshOn) => fetchWithDecoder_1(url_11, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg_3[1]])]), undefined, (response_4) => {
                            const pr_3 = response_4.arrayBuffer();
                            return pr_3.then((blob_3) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_3)), list_type(tuple_type(int32_type, string_type))));
                        }, refreshOn)))(true);
                    })), ["/api/files", fold((formData, image_1) => {
                        if (image_1.tag === 1) {
                        }
                        else {
                            const image_2 = image_1.fields[0];
                            formData.append(int32ToString(image_2.Position), image_2.File, image_2.File.name);
                        }
                        return formData;
                    }, new FormData(), newImages)], (Item_7) => (new Msg(10, [Item_7])), (Item_8) => (new Msg(39, [Item_8])))];
                }
                else {
                    const dto_2 = choose((setImage) => {
                        if (setImage.tag === 1) {
                            const image_3 = setImage.fields[0];
                            return new UpdateImagesDto(image_3.ImageUrl, image_3.Position);
                        }
                        else {
                            return undefined;
                        }
                    }, state.SetImages);
                    return [state, singleton((dispatch_2) => {
                        dispatch_2(new Msg(11, [dto_2]));
                    })];
                }
            }
        case 10: {
            const response_5 = msg.fields[0];
            if (response_5.tag === 1) {
                return [state, Cmd_errorToast("validation.toast")];
            }
            else {
                let dto_3;
                const list_6 = choose((setImage_1) => {
                    if (setImage_1.tag === 1) {
                        const image_4 = setImage_1.fields[0];
                        return new UpdateImagesDto(image_4.ImageUrl, image_4.Position);
                    }
                    else {
                        return undefined;
                    }
                }, state.SetImages);
                dto_3 = append(map((tupledArg_4) => (new UpdateImagesDto(tupledArg_4[1], tupledArg_4[0])), response_5.fields[0]), list_6);
                return [state, singleton((dispatch_3) => {
                    dispatch_3(new Msg(11, [dto_3]));
                })];
            }
        }
        case 11: {
            const matchValue_4 = state.Set;
            if (matchValue_4.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [state, updateImages(new SetId(parse(matchValue_4.fields[0].Id)), msg.fields[0], (Item_10) => (new Msg(12, [Item_10])), (Item_11) => (new Msg(39, [Item_11])))];
            }
        }
        case 12:
            if (msg.fields[0].tag === 1) {
                return [new State(state.Set, state.Tools, state.UserConfiguration, state.UserData, state.Customer, state.QuickOverviewDialog, state.Documents, state.CustomerConfiguration, state.Storages, state.BaseSet, state.ProblemReports, state.Notifications, state.Changelogs, empty(), state.AccountSettings, state.BusinessUnitImageUrl), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.Set, state.Tools, state.UserConfiguration, state.UserData, state.Customer, state.QuickOverviewDialog, state.Documents, state.CustomerConfiguration, state.Storages, state.BaseSet, state.ProblemReports, state.Notifications, state.Changelogs, empty(), state.AccountSettings, state.BusinessUnitImageUrl), Cmd_batch(ofArray([Cmd_successToast("general.upload_image_success"), singleton((dispatch_4) => {
                    dispatch_4(new Msg(30, []));
                })]))];
            }
        case 30: {
            const matchValue_5 = state.Set;
            if (matchValue_5.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const set$_1 = matchValue_5.fields[0];
                return [state, Cmd_batch(ofArray([Cmd_OfPromise_either((url_12) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url_12), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_7) => {
                    const pr_4 = response_7.arrayBuffer();
                    return pr_4.then((blob_4) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_4)), DataTransfer_DetailSet_$reflection()));
                })))), concat("/api/sets/", set$_1.Id, ..."/details"), (Item_12) => (new Msg(2, [Item_12])), (Item_13) => (new Msg(39, [Item_13]))), Cmd_OfPromise_either((url_15) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url_15), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_8) => {
                    const pr_5 = response_8.arrayBuffer();
                    return pr_5.then((blob_5) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_5)), DataTransfer_CreateOrUpdateSet_$reflection()));
                })))), concat("/api/sets/", set$_1.Id, ..."/basis"), (Item_14) => (new Msg(21, [Item_14])), (Item_15) => (new Msg(39, [Item_15])))]))];
            }
        }
        case 34:
            return [state, Cmd_batch(singleton(Cmd_ofEffect((_arg) => {
                RouterModule_nav(singleton("/tools"), 1, 1);
            })))];
        case 2: {
            const response_9 = msg.fields[0];
            return [new State(new RequestedValue$1(1, [response_9]), state.Tools, state.UserConfiguration, state.UserData, state.Customer, state.QuickOverviewDialog, state.Documents, state.CustomerConfiguration, state.Storages, state.BaseSet, state.ProblemReports, state.Notifications, state.Changelogs, map((image_5) => (new DnDFormImage(1, [{
                ImageUrl: image_5.ImageUrl,
                Position: image_5.Position,
            }])), response_9.SetImages), state.AccountSettings, state.BusinessUnitImageUrl), Cmd_batch(toList(delay(() => append_1(singleton_1(singleton((dispatch_5) => {
                dispatch_5(new Msg(32, []));
            })), delay(() => {
                const matchValue_6 = response_9.BusinessUnitId;
                return (matchValue_6 == null) ? singleton_1(singleton((dispatch_6) => {
                    dispatch_6(new Msg(35, [undefined]));
                })) : singleton_1(Cmd_OfPromise_either((url_18) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_20;
                    return ((url_20 = addPrefix_1(url_18), (refreshOn_1) => fetchWithDecoder_1(url_20, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_10) => {
                        const pr_6 = response_10.arrayBuffer();
                        return pr_6.then((blob_6) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_6)), option_type(string_type)));
                    }, refreshOn_1)))(true).then((_arg_1) => {
                        const result_7 = _arg_1;
                        return (result_7.tag === 1) ? (Promise.resolve((() => {
                            throw new ValidationOnGetRequest(result_7.fields[0]);
                        })())) : (Promise.resolve(result_7.fields[0]));
                    });
                })), concat("/api/business-units/", BusinessUnitId__get_unwrap(new BusinessUnitId(parse(matchValue_6))), ..."/image"), (Item_16) => (new Msg(35, [Item_16])), (Item_17) => (new Msg(39, [Item_17]))));
            })))))];
        }
        case 13: {
            onBlobReceived(msg.fields[0], msg.fields[1]);
            return [state, Cmd_none()];
        }
        case 16:
            return [new State(state.Set, state.Tools, state.UserConfiguration, state.UserData, state.Customer, {
                IsLoading: false,
                IsOpen: false,
            }, state.Documents, state.CustomerConfiguration, state.Storages, state.BaseSet, state.ProblemReports, state.Notifications, state.Changelogs, state.SetImages, state.AccountSettings, state.BusinessUnitImageUrl), Cmd_batch(ofArray([Cmd_OfPromise_either((url_21) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url_21), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_11) => {
                const pr_7 = response_11.arrayBuffer();
                return pr_7.then((blob_8) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_8)), UserConfiguration_$reflection()));
            })))), "/api/users/configuration", (Item_19) => (new Msg(17, [Item_19])), (Item_20) => (new Msg(39, [Item_20]))), Cmd_successToast("general.saved_successfully")]))];
        case 17:
            return [new State(state.Set, state.Tools, new RequestedValue$1(1, [msg.fields[0]]), state.UserData, state.Customer, state.QuickOverviewDialog, state.Documents, state.CustomerConfiguration, state.Storages, state.BaseSet, state.ProblemReports, state.Notifications, state.Changelogs, state.SetImages, state.AccountSettings, state.BusinessUnitImageUrl), Cmd_none()];
        case 18: {
            const matchValue_7 = state.Set;
            if (matchValue_7.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [state, Cmd_OfPromise_either((url_24) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url_24), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_12) => {
                    const pr_8 = response_12.arrayBuffer();
                    return pr_8.then((blob_9) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_9)), list_type(DocumentDetail_$reflection())));
                })))), concat("/api/sets/", SetId__get_unwrap(new SetId(parse(matchValue_7.fields[0].Id))), ..."/documents"), (Item_22) => (new Msg(25, [Item_22])), (Item_23) => (new Msg(39, [Item_23])))];
            }
        }
        case 19: {
            const matchValue_8 = state.Set;
            if (matchValue_8.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [state, Cmd_batch(ofArray([Cmd_successToast("general.download_started"), downloadFileCmd(new SetId(parse(matchValue_8.fields[0].Id)), msg.fields[0], msg.fields[1], (tupledArg_5) => (new Msg(20, [tupledArg_5[0], tupledArg_5[1]])), (Item_27) => (new Msg(39, [Item_27])))]))];
            }
        }
        case 3: {
            const matchValue_9 = state.BaseSet;
            const matchValue_10 = state.Set;
            let matchResult, dto_5, set$_4;
            if (matchValue_9.tag === 0) {
                matchResult = 1;
            }
            else if (matchValue_10.tag === 0) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
                dto_5 = matchValue_9.fields[0];
                set$_4 = matchValue_10.fields[0];
            }
            switch (matchResult) {
                case 0: {
                    const dto_6 = new DataTransfer_UpdateQrCodesDto(singleton(msg.fields[0]));
                    return [state, (setId_4 = (new SetId(parse(set$_4.Id))), (body_7 = toString(0, Auto_generateBoxedEncoder_437914C6(DataTransfer_UpdateQrCodesDto_$reflection(), undefined, undefined, undefined)(dto_6)), Cmd_OfPromise_either((tupledArg_6) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        let url_29;
                        return ((url_29 = addPrefix_1(tupledArg_6[0]), (refreshOn_2) => fetchWithDecoder_1(url_29, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg_6[1]])]), "application/json", (response_13) => {
                            const pr_9 = response_13.arrayBuffer();
                            return pr_9.then((blob_10) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_10)), string_type));
                        }, refreshOn_2)))(true);
                    })), [concat("/api/sets/", SetId__get_unwrap(setId_4), ..."/qr-codes/assign"), body_7], (Item_28) => (new Msg(23, [Item_28])), (Item_29) => (new Msg(39, [Item_29])))))];
                }
                default:
                    return [state, Cmd_none()];
            }
        }
        case 4: {
            const matchValue_12 = state.BaseSet;
            const matchValue_13 = state.Set;
            let matchResult_1, dto_7, set$_6;
            if (matchValue_12.tag === 0) {
                matchResult_1 = 1;
            }
            else if (matchValue_13.tag === 0) {
                matchResult_1 = 1;
            }
            else {
                matchResult_1 = 0;
                dto_7 = matchValue_12.fields[0];
                set$_6 = matchValue_13.fields[0];
            }
            switch (matchResult_1) {
                case 0: {
                    const dto_8 = new DataTransfer_UpdateQrCodesDto(msg.fields[0]);
                    return [state, (setId_5 = (new SetId(parse(set$_6.Id))), (body_9 = toString(0, Auto_generateBoxedEncoder_437914C6(DataTransfer_UpdateQrCodesDto_$reflection(), undefined, undefined, undefined)(dto_8)), Cmd_OfPromise_either((tupledArg_7) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        let url_32;
                        return ((url_32 = addPrefix_1(tupledArg_7[0]), (refreshOn_3) => fetchWithDecoder_1(url_32, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg_7[1]])]), "application/json", (response_14) => {
                            const pr_10 = response_14.arrayBuffer();
                            return pr_10.then((blob_11) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_11)), string_type));
                        }, refreshOn_3)))(true);
                    })), [concat("/api/sets/", SetId__get_unwrap(setId_5), ..."/qr-codes/unassign"), body_9], (Item_31) => (new Msg(24, [Item_31])), (Item_32) => (new Msg(39, [Item_32])))))];
                }
                default:
                    return [state, Cmd_none()];
            }
        }
        case 14: {
            const matchValue_15 = state.BaseSet;
            const matchValue_16 = state.Set;
            let matchResult_2, dto_9, set$_8;
            if (matchValue_15.tag === 0) {
                matchResult_2 = 1;
            }
            else if (matchValue_16.tag === 0) {
                matchResult_2 = 1;
            }
            else {
                matchResult_2 = 0;
                dto_9 = matchValue_15.fields[0];
                set$_8 = matchValue_16.fields[0];
            }
            switch (matchResult_2) {
                case 0: {
                    const dto_10 = new DataTransfer_CreateOrUpdateSet(dto_9.SetImages, dto_9.MasterData, dto_9.LocationInformation, List_distinct(append(msg.fields[0], dto_9.AssignedToolIds), {
                        Equals: (x_11, y) => (x_11 === y),
                        GetHashCode: (x_11) => (stringHash(x_11) | 0),
                    }), dto_9.QRCodeIds, dto_9.LabelIds, dto_9.BusinessUnitId);
                    return [state, (setId_6 = (new SetId(parse(set$_8.Id))), (body_11 = toString(0, Auto_generateBoxedEncoder_437914C6(DataTransfer_CreateOrUpdateSet_$reflection(), undefined, undefined, undefined)(dto_10)), Cmd_OfPromise_either((tupledArg_8) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        let url_35;
                        return ((url_35 = addPrefix_1(tupledArg_8[0]), (refreshOn_4) => fetchWithDecoder_1(url_35, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg_8[1]])]), "application/json", (response_15) => {
                            const pr_11 = response_15.arrayBuffer();
                            return pr_11.then((blob_12) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_12)), string_type));
                        }, refreshOn_4)))(true);
                    })), [concat("/api/sets/", ...SetId__get_unwrap(setId_6)), body_11], (Item_34) => (new Msg(22, [Item_34])), (Item_35) => (new Msg(39, [Item_35])))))];
                }
                default:
                    return [state, Cmd_none()];
            }
        }
        case 15: {
            const matchValue_18 = state.BaseSet;
            const matchValue_19 = state.Set;
            let matchResult_3, dto_11, set$_10;
            if (matchValue_18.tag === 0) {
                matchResult_3 = 1;
            }
            else if (matchValue_19.tag === 0) {
                matchResult_3 = 1;
            }
            else {
                matchResult_3 = 0;
                dto_11 = matchValue_18.fields[0];
                set$_10 = matchValue_19.fields[0];
            }
            switch (matchResult_3) {
                case 0: {
                    const dto_12 = new DataTransfer_CreateOrUpdateSet(dto_11.SetImages, dto_11.MasterData, dto_11.LocationInformation, List_distinct(filter((toolId) => !contains(toolId, msg.fields[0], {
                        Equals: (x_13, y_1) => (x_13 === y_1),
                        GetHashCode: (x_13) => (stringHash(x_13) | 0),
                    }), dto_11.AssignedToolIds), {
                        Equals: (x_14, y_2) => (x_14 === y_2),
                        GetHashCode: (x_14) => (stringHash(x_14) | 0),
                    }), dto_11.QRCodeIds, dto_11.LabelIds, dto_11.BusinessUnitId);
                    return [state, (setId_7 = (new SetId(parse(set$_10.Id))), (body_13 = toString(0, Auto_generateBoxedEncoder_437914C6(DataTransfer_CreateOrUpdateSet_$reflection(), undefined, undefined, undefined)(dto_12)), Cmd_OfPromise_either((tupledArg_9) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        let url_38;
                        return ((url_38 = addPrefix_1(tupledArg_9[0]), (refreshOn_5) => fetchWithDecoder_1(url_38, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg_9[1]])]), "application/json", (response_16) => {
                            const pr_12 = response_16.arrayBuffer();
                            return pr_12.then((blob_13) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_13)), string_type));
                        }, refreshOn_5)))(true);
                    })), [concat("/api/sets/", ...SetId__get_unwrap(setId_7)), body_13], (Item_37) => (new Msg(22, [Item_37])), (Item_38) => (new Msg(39, [Item_38])))))];
                }
                default:
                    return [state, Cmd_none()];
            }
        }
        case 22:
            if (msg.fields[0].tag === 1) {
                return [state, Cmd_errorToast("validation.toast")];
            }
            else {
                return [state, Cmd_batch(ofArray([singleton((dispatch_7) => {
                    dispatch_7(new Msg(30, []));
                }), Cmd_successToast("general.saved_successfully")]))];
            }
        case 23: {
            const response_18 = msg.fields[0];
            if (response_18.tag === 1) {
                const matchValue_21 = tryFind((validation) => (validation.AffectedProperty === "qr_code"), response_18.fields[0].Validations);
                if (matchValue_21 == null) {
                    return [state, Cmd_errorToast("validation.toast")];
                }
                else {
                    return [state, Cmd_errorToast(matchValue_21.ErrorMessage)];
                }
            }
            else {
                return [state, Cmd_batch(ofArray([singleton((dispatch_8) => {
                    dispatch_8(new Msg(30, []));
                }), Cmd_successToast("general.saved_successfully")]))];
            }
        }
        case 24:
            if (msg.fields[0].tag === 1) {
                return [state, Cmd_errorToast("validation.toast")];
            }
            else {
                return [state, Cmd_batch(ofArray([singleton((dispatch_9) => {
                    dispatch_9(new Msg(30, []));
                }), Cmd_successToast("general.saved_successfully")]))];
            }
        case 21:
            return [new State(state.Set, state.Tools, state.UserConfiguration, state.UserData, state.Customer, state.QuickOverviewDialog, state.Documents, state.CustomerConfiguration, state.Storages, new RequestedValue$1(1, [msg.fields[0]]), state.ProblemReports, state.Notifications, state.Changelogs, state.SetImages, state.AccountSettings, state.BusinessUnitImageUrl), Cmd_none()];
        case 31:
            return [state, getAssignableTools((Item_40) => (new Msg(26, [Item_40])), (Item_41) => (new Msg(39, [Item_41])))];
        case 26:
            return [new State(state.Set, new RequestedValue$1(1, [msg.fields[0]]), state.UserConfiguration, state.UserData, state.Customer, state.QuickOverviewDialog, state.Documents, state.CustomerConfiguration, state.Storages, state.BaseSet, state.ProblemReports, state.Notifications, state.Changelogs, state.SetImages, state.AccountSettings, state.BusinessUnitImageUrl), Cmd_none()];
        case 20:
            return [state, getBlob(msg.fields[0], msg.fields[1], (tupledArg_10) => (new Msg(13, [tupledArg_10[0], tupledArg_10[1]])), (Item_44) => (new Msg(39, [Item_44])))];
        case 28:
            return [new State(state.Set, state.Tools, state.UserConfiguration, state.UserData, state.Customer, state.QuickOverviewDialog, state.Documents, state.CustomerConfiguration, new RequestedValue$1(1, [msg.fields[0]]), state.BaseSet, state.ProblemReports, state.Notifications, state.Changelogs, state.SetImages, state.AccountSettings, state.BusinessUnitImageUrl), Cmd_none()];
        case 25:
            return [new State(state.Set, state.Tools, state.UserConfiguration, state.UserData, state.Customer, state.QuickOverviewDialog, new RequestedValue$1(1, [msg.fields[0]]), state.CustomerConfiguration, state.Storages, state.BaseSet, state.ProblemReports, state.Notifications, state.Changelogs, state.SetImages, state.AccountSettings, state.BusinessUnitImageUrl), Cmd_none()];
        case 29:
            return [new State(state.Set, state.Tools, state.UserConfiguration, state.UserData, state.Customer, state.QuickOverviewDialog, state.Documents, state.CustomerConfiguration, state.Storages, state.BaseSet, new RequestedValue$1(1, [msg.fields[0]]), state.Notifications, state.Changelogs, state.SetImages, state.AccountSettings, state.BusinessUnitImageUrl), Cmd_none()];
        case 27:
            return [new State(state.Set, state.Tools, state.UserConfiguration, state.UserData, state.Customer, state.QuickOverviewDialog, state.Documents, new RequestedValue$1(1, [msg.fields[0]]), state.Storages, state.BaseSet, state.ProblemReports, state.Notifications, state.Changelogs, state.SetImages, state.AccountSettings, state.BusinessUnitImageUrl), Cmd_none()];
        case 32: {
            const matchValue_22 = state.Set;
            if (matchValue_22.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [state, getSetNotifications(new SetId(parse(matchValue_22.fields[0].Id)), (Item_46) => (new Msg(33, [Item_46])), (Item_47) => (new Msg(39, [Item_47])))];
            }
        }
        case 33:
            return [new State(state.Set, state.Tools, state.UserConfiguration, state.UserData, state.Customer, state.QuickOverviewDialog, state.Documents, state.CustomerConfiguration, state.Storages, state.BaseSet, state.ProblemReports, new RequestedValue$1(1, [msg.fields[0]]), state.Changelogs, state.SetImages, state.AccountSettings, state.BusinessUnitImageUrl), Cmd_none()];
        case 36: {
            const matchValue_23 = state.Set;
            if (matchValue_23.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [state, getChangelogs(matchValue_23.fields[0].Id, (Item_48) => (new Msg(37, [Item_48])), (Item_49) => (new Msg(39, [Item_49])))];
            }
        }
        case 37:
            return [new State(state.Set, state.Tools, state.UserConfiguration, state.UserData, state.Customer, state.QuickOverviewDialog, state.Documents, state.CustomerConfiguration, state.Storages, state.BaseSet, state.ProblemReports, state.Notifications, new RequestedValue$1(1, [msg.fields[0]]), state.SetImages, state.AccountSettings, state.BusinessUnitImageUrl), Cmd_none()];
        case 38:
            return [new State(state.Set, state.Tools, state.UserConfiguration, state.UserData, state.Customer, state.QuickOverviewDialog, state.Documents, state.CustomerConfiguration, state.Storages, state.BaseSet, state.ProblemReports, state.Notifications, state.Changelogs, state.SetImages, new RequestedValue$1(1, [msg.fields[0]]), state.BusinessUnitImageUrl), Cmd_none()];
        case 35:
            return [new State(state.Set, state.Tools, state.UserConfiguration, state.UserData, state.Customer, state.QuickOverviewDialog, state.Documents, state.CustomerConfiguration, state.Storages, state.BaseSet, state.ProblemReports, state.Notifications, state.Changelogs, state.SetImages, state.AccountSettings, new RequestedValue$1(1, [msg.fields[0]])), Cmd_none()];
        case 39:
            return [state, Cmd_none()];
        default: {
            const matchValue = state.UserConfiguration;
            if (matchValue.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const userConfiguration = matchValue.fields[0];
                return [new State(state.Set, state.Tools, state.UserConfiguration, state.UserData, state.Customer, {
                    IsLoading: true,
                    IsOpen: state.QuickOverviewDialog.IsOpen,
                }, state.Documents, state.CustomerConfiguration, state.Storages, state.BaseSet, state.ProblemReports, state.Notifications, state.Changelogs, state.SetImages, state.AccountSettings, state.BusinessUnitImageUrl), (userConfiguration_1 = (new UserConfiguration_1(userConfiguration.TableConfiguration, (bind$0040_1 = userConfiguration.QuickOverviewConfiguration, new QuickOverviewConfiguration_1(bind$0040_1.ConsumableViewVisibleFieldKeys, bind$0040_1.ToolWithQuantityViewVisibleFieldKeys, msg.fields[0])))), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(tupledArg[0]), ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                    const pr = response.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), EmptyResponse_$reflection()));
                })))), ["/api/users/configuration", toString(0, Auto_generateBoxedEncoder_437914C6(UserConfiguration_$reflection(), undefined, undefined, undefined)(userConfiguration_1))], (Item) => (new Msg(16, [Item])), (Item_1) => (new Msg(39, [Item_1]))))];
            }
        }
    }
}

